import { Card } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { DESELECT_MESSAGE } from '../../../../../../../../common/constants';
import CommonTooltip from '../../../../../../../../components/CommonTooltip';
import StageListTable from './StageListTable';

const StageList = ({
  setStageId,
  stageId,
  eqcTypeData,
  setStageData,
  isSequenceChanged,
  setIsSequenceChanged,
  setTitle,
  title,
  isEditable,
  refetchRef,
  stageData,
  isStageItemSelectionActive,
  setIsStageSelectionActive,
}) => {
  return (
    <Card className="stage-list-card project-stages">
      <div className="header d-flex align-center justify-between mb-10">
        <h2>Checklist Stage</h2>
        <div className="eqc-stage-header-buttons d-flex">
          <div id="eqc-details-btn" className="d-flex" />
          <div id="add-btn" />
        </div>
      </div>
      <div id="stage-selection-bar" className="mb-10" />
      <div className={clsx(isStageItemSelectionActive && 'stage-list-disabled')}>
        {isStageItemSelectionActive && (
          <CommonTooltip title={DESELECT_MESSAGE}>
            <div className="disabled-overlay" />
          </CommonTooltip>
        )}
        <StageListTable
          setStageId={setStageId}
          stageId={stageId}
          setTitle={setTitle}
          title={title}
          eqcTypeData={eqcTypeData}
          setStageData={setStageData}
          isSequenceChanged={isSequenceChanged}
          setIsSequenceChanged={setIsSequenceChanged}
          isEditable={isEditable}
          refetchRef={refetchRef}
          stageData={stageData}
          isStageItemSelectionActive={isStageItemSelectionActive}
          setIsStageSelectionActive={setIsStageSelectionActive}
        />
      </div>
    </Card>
  );
};

export default StageList;
